import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  AGENT_LAN,
  API,
  SELECTION_KEY,
  N_AGENT_LANGUAGE_UPDATE,
  AGENT_MODE,
  NiCommonCascader,
  SelectionOption,
  getSelectionOptions,
  PAGE_TYPE
} from '@config/index';
import {
  UserContext,
  UserContextProps,
  UserProps,
  OrgContextProps,
  OrgInfo,
  AgentInfo,
  AgentContextProps,
  AgentContext,
  OrgContext,
  agentToLocal,
  StarInfo,
  starInfoToLocal
} from '@interface/index';
import {
  NiMenu,
  NiSpin,
  NiModal,
  niConfirm,
  NiForm,
  NiSelect
} from '@component/index';
import addOrg from '@page/org/add-org';
import {
  DownOutlined,
  CheckOutlined,
  FileZipOutlined,
  ShareAltOutlined,
  CopyOutlined,
  StarOutlined,
  StarFilled
} from '@ant-design/icons';
import { message, Dropdown, Button, Menu, Space, Divider } from 'antd';
import { isEqual, instance, isProviderAgent, getAgentInfo, getOrgId, isReadMode, getUserId, getAgentPathPrefix, getMasterAgentName, orgNameToPathComponent, getAgentId, isSingleLanguageAgent, isPostgresProviderAgent, isBotAgent, isOpencuiHostBotAgent, isOperatePage, isBuildPage, isDebugPage, isPublicAgent, getOrgName, isHostedProviderAgent, isSupabaseProviderAgent } from '@lib/index';
import { localizedString } from '@locale/index';

const { SubMenu } = NiMenu;

import './index.less';
import { AgentPermission, AGENT_OPERATION } from '@permission/agent';
import * as FileSaver from 'file-saver';
import { debounce } from 'lodash';
import { AgentCreateModal } from '@page/agent/create';
import { Selector } from 'react-redux';
import { contains } from 'validator';
import { DefaultOptionType } from 'antd/lib/select';

const AddOrg = addOrg;


export interface NavBarPropsInfo {
  location: any;
  match: any;
  user: UserProps;
  org: OrgInfo;
  agent?: AgentInfo;
  history: any;
  staticTitle?: string;
  tabComp?: React.ReactNode;
}

export interface NavBarStateInfo {
  loading: boolean;
  orgList: OrgInfo[];
  agentList: AgentInfo[];
  structId?: string;
  structInfo?: AgentInfo;
  deploying: boolean;
  action?: 'clone' | 'import';
  cloneDest?: string;
  cloneDestName?: string;
  importOrgOpts: SelectionOption[];
  importSourceOrg?: string;
  importAgentOpts: SelectionOption[];
  importSource?: string;
  importing: boolean;
  cloneModalVisible: boolean;
  starInfo?: StarInfo;
}

const defaultState: NavBarStateInfo = {
  loading: false,
  orgList: [],
  agentList: [],
  deploying: false,
  importing: false,
  importAgentOpts: [],
  importOrgOpts: [],
  cloneModalVisible: false
};


class NavBarComp extends React.Component<NavBarPropsInfo, NavBarStateInfo> {
  public state: NavBarStateInfo = { ...defaultState };

  componentDidMount() {
    this.initAgentList();
    this.initNormal();
  }

  initAgentList = async () => {
    let agentList: any = [];
    if (getOrgId() && getAgentId()) {
      agentList = await API.agent
        .getAgents()
        .then((res: any) => res
          .filter((item: any) => item.lang === AGENT_LAN.STRUCT)
          .map(agentToLocal))
        .catch((err: any) => {
          this.setState({
            loading: false
          });
          message.warning(err.message);

          throw new Error(err.message);
        });
    }

    this.setState({
      agentList
    });
  }

  initNormal = async () => {
    const { agent, user, staticTitle } = this.props;

    if (staticTitle) {
      return;
    }

    this.setState({
      loading: true
    });

    let structId: string | undefined;
    let structInfo: AgentInfo | undefined;

    if (agent) {
      if (agent.language === AGENT_LAN.STRUCT) {
        structId = agent.id;
        structInfo = getAgentInfo();
      } else if (agent.structKey) {
        structId = agent.structKey.agentId;

        if (structId !== this.state.structId || !this.state.structInfo) {

          structInfo = await API.agent.getAgentById(structId)
            .then((res: any) => res && agentToLocal(res))
            .catch((err: any) => {
              this.setState({
                loading: false
              });
              message.warning(err.message);
              throw new Error(err.message);
            });
        } else {
          structInfo = this.state.structInfo;
        }
      }
    }

    this.setState({
      structId,
      structInfo,
      loading: false
    }, this.updateStarInfo);

  }

  updateStarInfo = () => {
    if (this.props.agent) {
      API.agent.starInfo()
        .then(starInfoToLocal)
        .then((starInfo: StarInfo) => {
          this.setState({ starInfo });
        })
        .catch((error: Error) => {
          message.error(error.message);
        });
    }
  }

  render() {
    const { agent, user, history, org, staticTitle, location, match, tabComp } = this.props;
    const {
      loading,
      orgList,
      structId,
      structInfo,
      deploying,
      importing,
      action,
      cloneModalVisible,
      cloneDest,
      cloneDestName,
      importSource,
      importOrgOpts,
      importSourceOrg,
      importAgentOpts,
      starInfo
    } = this.state;

    return <div className="nav-bar" key={agent && agent.id}>
      <NiSpin spinning={loading}>
        <span className="nav-wrapper">
          {staticTitle || ''}
          {
            agent && agent.mode !== AGENT_MODE.KNOWLEDGE && <NiSelect
              className="user-layer-select"
              value={isOperatePage() ? 'operate' : isBuildPage() ? 'build' : 'test'}
              style={{ backgroundColor: 'inherit !important', width: 100 }}
              onChange={(value: string) => {

                if (value === 'build') {
                  if (isBuildPage()) {
                    return;
                  }

                  if (agent.mode === AGENT_MODE.KNOWLEDGE) {
                    history.push(`/org/${getOrgName()}/agent/${agent.name}/${agent.language}/knowledge`);
                    return;
                  }

                  history.push(`${getAgentPathPrefix()}/type`);
                } else if (value === 'operate') {
                  if (isOperatePage()) {
                    return;
                  }

                  history.push(`${getAgentPathPrefix()}/${(isBotAgent() || isHostedProviderAgent()) ? 'deploy' : 'operate_setting?tab=general'}`);
                } else {
                  if (isDebugPage()) {
                    return;
                  }

                  history.push(`${getAgentPathPrefix()}/debug`);
                }
              }}
            >
              <NiSelect.Option key="build" value="build">Build</NiSelect.Option>
              <NiSelect.Option key="test" value="test" disabled={isPostgresProviderAgent() || isSupabaseProviderAgent()}
              >Test</NiSelect.Option>
              <NiSelect.Option key="operate" value="operate"
                disabled={!(isOpencuiHostBotAgent() || isHostedProviderAgent()) || (isBotAgent() && isPublicAgent())}
              >Operate</NiSelect.Option>
            </NiSelect>
          }
        </span>
      </NiSpin>
      {
        <span className="tab-container" style={{
          width: '100%',
          marginLeft: 24,
          marginRight: 24,
          display: 'flex',
          alignItems: 'center'
        }}>
          {
            tabComp
          }
        </span>

      }
      <Space size={16} >
        {
          agent && agent.mode === AGENT_MODE.KNOWLEDGE &&
          AgentPermission(AGENT_OPERATION.DEPLOY) &&
          <>
            <div className="button-area" onClick={this.handleDeploy} >
              <FileZipOutlined spin={deploying} style={{ marginRight: 10 }} />
              {localizedString('agent_deploy')}
            </div>
          </>
        }
        {/* {
          agent &&
          !isReadMode() &&
          (agent.mode === AGENT_MODE.APPLICATION ||
            (agent.isService && agent.isInterface)) &&
          // agent.deployMode === AGENT_DEPLOY_MODE.PRIVATE &&
          AgentPermission(AGENT_OPERATION.DEPLOY) &&
          <>
            <div className="button-area" onClick={this.handleExport} >
              <FileZipOutlined spin={deploying} style={{ marginRight: 10 }} />
              {localizedString('agent_export')}
            </div>
          </>
        } */}
        {
          (structInfo || isSingleLanguageAgent()) && agent && agent.mode !== AGENT_MODE.KNOWLEDGE &&
          <>
            <div id="unique-btn-clone" className="button-area" key="clone" onClick={() => {
              // this.setState({ action: 'clone', cloneDest: undefined });
              this.setState({ cloneModalVisible: true });
            }}>
              <CopyOutlined style={{ marginRight: 10 }} />
              {localizedString('clone_project')}
            </div>
            {/* {
              <div id="uinique-btn-import" className="button-area" key="import" onClick={() => {
                this.setState({ action: 'import', importSource: undefined }, this.initImportOrgOptions);
              }}>
                <ShareAltOutlined spin={importing} style={{ marginRight: 10 }} />
                {localizedString('import_project')}
              </div>
            } */}
            <div className="button-area" key="star" onClick={() => {
              if (loading) {
                return;
              }

              this.setState({ loading: true });

              if (starInfo && starInfo.starred) {
                API.agent.removeAgentStar()
                  .then(() => {
                    this.setState({ loading: false });
                  })
                  .then(this.updateStarInfo)
                  .catch((err: any) => {
                    message.error(err.message);
                  });
              } else {
                API.agent.starAgent()
                  .then(() => {
                    this.setState({ loading: false });
                  })
                  .then(this.updateStarInfo)
                  .catch((err: any) => {
                    message.error(err.message);
                  });
              }
            }}>
              {starInfo && starInfo.starred ?
                <StarFilled style={{ marginRight: 10, color: '#f8ba00' }} />
                : <StarOutlined style={{ marginRight: 10 }} />
              }
              {localizedString('project_star', undefined, 'Star')}
              <span style={{ marginLeft: 4 }}>{starInfo && starInfo.starCount || '0'}</span>
            </div>
          </>
        }
        {
          agent && agent.role &&
          <>
            <Divider type="vertical" />
            <label className="nav-label" >{localizedString(`agent_role_${agent.role}`)}</label>
          </>

        }
      </Space>
      {
        action &&
        <NiModal
          title={localizedString(action === 'clone' ? 'clone_project' : 'import_a_module')}
          open={!!action}
          onOk={this.handleAction}
          okText={localizedString(action === 'clone' ? 'clone_project' : 'import_project')}
          onCancel={() => {
            this.setState({ action: undefined });
          }}
          className="project_action_modal"
        >
          <NiForm
            items={[
              action === 'clone'
                ? {
                  key: 'clone',
                  label: localizedString('clone_to'),
                  content: <NiCommonCascader
                    rootpath={[{
                      value: structId || agent?.id || '',
                      value_type: 'agent'
                    }]}
                    selectionkey={SELECTION_KEY.CLONE_DESTINATION}
                    value={cloneDest && [cloneDest] || []}
                    onChange={(value: string[], options?: SelectionOption[]) => {
                      this.setState({
                        cloneDest: value.length ? value[0] : undefined,
                        cloneDestName: (options && options.length) ? options[0].label as string : ''
                      });
                    }}
                  />
                }
                : {
                  key: 'import',
                  label: <label style={{ marginTop: 4 }}>{localizedString('import_from', undefined, 'Import from')}</label>,
                  content: <Space>
                    {/* <NiCommonCascader
                      allowSearch
                      rootpath={[]}
                      style={{ width: '100%' }}
                      selectionkey={SELECTION_KEY.IMPORT_SOURCE}
                      value={importSource || []}
                      onChange={(value: string[]) => {
                        this.setState({ importSource: value.length ? value : undefined });
                      }}
                    /> */}
                    <NiSelect
                      placement="bottomLeft"
                      showSearch
                      filterOption={(input: string, option: any) => {
                        return option && input && (option.children as string).toLowerCase().indexOf(input.trim().toLowerCase()) !== -1 || false;
                      }}
                      listHeight={200}
                      placeholder={localizedString('org_select', undefined, 'Select org')}
                      key="select-import-org"
                      value={importSourceOrg}
                      onChange={(value: string) => {
                        this.setState({ importSourceOrg: value }, this.initImportAgentOptions);
                      }}
                    >
                      {
                        importOrgOpts.map((opt: SelectionOption) => <NiSelect.Option key={opt.value} value={opt.value}>{opt.label}</NiSelect.Option>)
                      }
                    </NiSelect>

                    <NiSelect
                      placement="bottomLeft"
                      showSearch
                      filterOption={(input: string, option: any) => {
                        return option && input && (option.children as string).toLowerCase().indexOf(input.trim().toLowerCase()) !== -1 || false;
                      }}
                      listHeight={200}
                      placeholder={localizedString('module_select', undefined, 'Select module')}
                      key="select-import-agent"
                      value={importSource}
                      onChange={(value: string) => {
                        this.setState({ importSource: value });
                      }}
                    >
                      {
                        importAgentOpts.map((opt: SelectionOption) => <NiSelect.Option key={opt.value} value={opt.value}>{opt.label}</NiSelect.Option>)
                      }
                    </NiSelect>
                  </Space>

                }
            ]}
          />
        </NiModal>
      }
      {
        agent && cloneModalVisible &&
        <AgentCreateModal
          isCloning
          key={structId}
          type={agent.mode === AGENT_MODE.APPLICATION
            ? 'chatbot'
            : (agent.isService && !agent.isInterface)
              ? 'backend'
              : 'component'}
          visible={cloneModalVisible}
          location={location}
          match={match}
          history={history}
          cloneToOrgId={cloneDest}
          cloneToOrgName={cloneDestName}
          cloneAgent={structInfo || agent}
          didCloseClick={() => {
            this.setState({ cloneModalVisible: false, action: undefined });
          }}
        />
      }
    </div >;
  }

  initImportOrgOptions = async () => {
    const opts = await getSelectionOptions(SELECTION_KEY.IMPORT_SOURCE);
    this.setState({ importOrgOpts: opts });
  }

  initImportAgentOptions = async () => {
    const { importSourceOrg } = this.state;
    const opts = await getSelectionOptions(SELECTION_KEY.IMPORT_SOURCE, [{
      value: importSourceOrg || '',
      value_type: 'org',
    }]);
    this.setState({ importAgentOpts: opts });
  }

  getSelectedKeys = () => {
    const path = window.location.pathname;

    // if (path.endsWith('library')) {
    //   return ['imported'];
    // }

    if (path.endsWith('version')) {
      return ['version'];
    }
    return ['build'];
  }

  b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  handleExport = async () => {
    this.setState({ deploying: true });

    try {
      const res: any = await API.agent.export(this.state.structId);
      const blob = this.b64toBlob(res.data, 'application/zip');
      FileSaver.saveAs(blob, res.filename);
    } catch (e: any) {
      niConfirm({
        width: '60%',
        title: localizedString('common_error_info'),
        content: <pre style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all'
        }}>{e.message}</pre>
      });
    } finally {
      this.setState({ deploying: false });
    }
  }

  handleDeploy = async () => {
    this.setState({ deploying: true });
    try {
      await API.knowledge.deploy();
      this.initNormal();
      instance.emit('redeployed');
    } catch (e: any) {

      niConfirm({
        width: '60%',
        title: localizedString('common_error_info'),
        content: <pre style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all'
        }}>{e.message}</pre>
      });
    } finally {
      this.setState({ deploying: false });
    }
  }

  handleAction = debounce(async () => {
    const { action, cloneDest } = this.state;
    if (action === 'clone') {
      this.setState({ cloneModalVisible: true });
    } else if (action === 'import') {
      this.defaultImport(true);
    }
  }, 500);

  defaultImport = async (check?: boolean) => {
    const { agent } = this.props;
    const { importSource, structInfo } = this.state;

    this.setState({ action: undefined });

    const hostAgent = structInfo || agent;

    if (check) {
      const hostKey = {
        agentId: hostAgent && hostAgent.id || '',
        userId: getUserId(),
        commitNumber: ''
      };

      const originKey = importSource && {
        agentId: importSource,
        userId: 'master',
        commitNumber: ''
      } || undefined;

      if (!originKey) {
        return;
      }

      this.setState({ importing: true });
      const res: any = await API.agent.libraryCheck(
        'import',
        originKey,
        undefined,
        hostKey
      ).catch((err: Error) => {
        this.setState({ importing: false });
        message.error(err.message);
        throw err;
      });
      this.setState({ importing: false });
      const msg = res.messages && res.messages.length && res.messages.join('\n');
      if (res.not_allow) {
        message.error(msg || localizedString('common_not_allowed'));
        return;
      }

      if (res.not_encourage) {
        niConfirm({
          title: 'Confirm',
          icon: null,
          content: msg,
          onOk: () => {
            this.defaultImport();
          }
        });
        return;
      }
    }

    this.handleImport();
  }

  handleImport = async () => {

    const { agent } = this.props;
    const { importSource, structInfo } = this.state;

    this.setState({ action: undefined });

    const hostAgent = structInfo || agent;

    this.setState({ importing: true });

    const hostKey = {
      agentId: hostAgent && hostAgent.id || '',
      userId: getUserId(),
      commitNumber: ''
    };

    const originKey = importSource && {
      agentId: importSource,
      userId: 'master',
      commitNumber: ''
    } || undefined;

    if (!originKey) {
      return;
    }

    await API.agent.importLibray(
      originKey, hostKey
    ).catch((err: any) => {
      const errMsg = err.data && err.data.length && err.data[0] || err.message;
      message.error(errMsg);
      this.setState({ importing: false });
      throw new Error(errMsg);
    });

    this.setState({ importing: false });
  }
}


export const NavBar = (props: any) => (
  <UserContext.Consumer>
    {($user: UserContextProps) => (
      <OrgContext.Consumer>
        {($org: OrgContextProps) => (
          <AgentContext.Consumer>
            {($agent: AgentContextProps) => <NavBarComp
              {...props}
              user={$user.user}
              org={$org.org}
              agent={$agent.agent}
              key={$org.org && $org.org.id}
            />}
          </AgentContext.Consumer>
        )}
      </OrgContext.Consumer>
    )}
  </UserContext.Consumer>
);
